module.exports = __webpack_public_path__ + "static/media/20-iveco.dce864c5.jpg";